import { gql, useLazyQuery } from "@apollo/client";
import { AsyncQueryStatus } from "../../models/AsyncActionStatus";
import { getErrors } from "../../utils";
import { GetInvoiceItems, GetInvoiceItemsVariables } from "./__generated__/GetInvoiceItems";

export const GET_INVOICE_ITEMS = gql`
  query GetInvoiceItems($skip: Int, $take: Int, $orgId: String) {
    invoiceItems(skip: $skip, take: $take, orgId: $orgId) {
      totalCount
      items {
        id
        startDate
        endDate
        amount
        sent
        organization {
          id
          name
        }
      }
    }
  }
`;

export function useLazyGetInvoiceItems() {
  const [getInvoiceItems, { loading, error, data }] = useLazyQuery<GetInvoiceItems, GetInvoiceItemsVariables>(
    GET_INVOICE_ITEMS,
    {
      fetchPolicy: "cache-and-network",
      errorPolicy: "all",
    }
  );

  return {
    getInvoiceItems,
    data,
    status: {
      loading,
      errors: getErrors(error),
      successful: !error && data ? true : false,
    } as AsyncQueryStatus,
  };
}
